import reduceReducers from "reduce-reducers";
import { initialState as projectDetailsInitialState, reducer as projectDetailsReducer } from "../projectDetails";
import { initialState as projectEditorPanelInitialState, reducer as projectEditorPanelReducer } from "../projectEditorPanel";
export const initialState = {
    ...projectEditorPanelInitialState,
    ...projectDetailsInitialState
};
export default reduceReducers(initialState, projectEditorPanelReducer, projectDetailsReducer);
